"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @class Field
 * @description an input field, this handles label, description, hint and error message
 */
var PropTypes = require("prop-types");
var React = require("react");
var Messages = require("../../codegen/Messages");
var types_1 = require("./types");
var FieldError_1 = require("./FieldError");
var index_1 = require("../../index");
var unicode_1 = require("../../utils/unicode");
var util_1 = require("../../utils/util");
/**
 * Provide context with the legacy context api so as not to break downstreams.
 *
 * @deprecated Remove at next major version bump: https://jira.oci.oraclecorp.com/browse/UIPLAT-1620
 */
var LegacyFieldContextProvider = /** @class */ (function (_super) {
    __extends(LegacyFieldContextProvider, _super);
    function LegacyFieldContextProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LegacyFieldContextProvider.prototype.getChildContext = function () {
        var _a = this.props, fieldName = _a.fieldName, hintId = _a.hintId, errorId = _a.errorId, fieldId = _a.fieldId, label = _a.label;
        return { fieldName: fieldName, hintId: hintId, errorId: errorId, fieldId: fieldId, label: label };
    };
    LegacyFieldContextProvider.prototype.render = function () {
        return this.props.children;
    };
    LegacyFieldContextProvider.childContextTypes = {
        fieldName: PropTypes.string,
        fieldId: PropTypes.string,
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.element,
            PropTypes.arrayOf(PropTypes.element)
        ]),
        hintId: PropTypes.string,
        errorId: PropTypes.string
    };
    return LegacyFieldContextProvider;
}(React.Component));
/**
 * OUI field component
 * Provides the common visual elements to a control like: label,
 * required marker, read only marker, hint, tooltip, and validation error.
 *
 * @oui-component Field
 */
var Field = /** @class */ (function (_super) {
    __extends(Field, _super);
    function Field(props) {
        var _this = _super.call(this, props) || this;
        _this.fieldId = props.fieldName.replace(/\W/g, "_") + "-" + util_1.uniqueGUID();
        return _this;
    }
    Field.prototype.render = function () {
        var _a = this.props, children = _a.children, fieldName = _a.fieldName, hint = _a.hint, tooltip = _a.tooltip, label = _a.label, optional = _a.optional, readOnly = _a.readOnly, error = _a.error, testId = _a.testId;
        var hintId = hint ? this.fieldId + "-hint" : undefined;
        var errorId = this.fieldId + "-error";
        var className = "oui-margin-small-bottom oui-form-field oui-react-form-field";
        var labelElement = (React.createElement("label", { 
            // tslint:disable-next-line:max-line-length
            className: "oui-form-label oui-react-form-label oui-margin-small-bottom oui-display-inline-block", htmlFor: this.fieldId, "data-test-id": testId }, label));
        var checkboxLabelElement = (React.createElement("label", { className: "oui-form-label oui-react-form-label", htmlFor: this.fieldId, "data-test-id": testId }, label));
        var hintElement = hint ? (React.createElement("div", { className: "oui-text-small oui-text-muted", id: hintId }, hint)) : null;
        var tooltipElement = tooltip && (React.createElement(React.Fragment, null,
            React.createElement(index_1.Button, { type: index_1.ButtonType.Button, buttonStyle: index_1.ButtonStyle.Link },
                React.createElement(index_1.IconElement, { ariaLabel: Messages.Common.moreInfo(), label: Messages.Common.moreInfo(), icon: index_1.Icon.Info })),
            React.createElement(index_1.Tooltip, null, tooltip)));
        var descriptionFlag = null;
        if (optional) {
            // CDS pattern
            // descriptionFlag = <span className="oui-text-small oui-text-muted oui-margin-small-bottom">(Optional)</span>;
            // HgDS pattern
            descriptionFlag = (React.createElement("span", { className: "oui-react-optional-text oui-text-small oui-text-muted oui-margin-small-bottom oui-margin-left" }, Messages.Field.optional()));
        }
        else if (readOnly) {
            // CDS pattern
            // descriptionFlag = <span className="oui-text-small oui-text-muted oui-margin-small-bottom">(Read-Only)</span>;
            // HgDS pattern
            descriptionFlag = (React.createElement("span", { className: "oui-react-readonly-text oui-text-small oui-text-muted oui-margin-small-bottom oui-margin-left oui-text-nowrap" }, Messages.Field.readOnly()));
        }
        // the layout for a checkbox is a little different than other Components
        // TODO: consider creating a CheckBoxfield component to render here
        if (typeof children === "object" && children.type === index_1.CheckBox) {
            return (React.createElement("div", { className: className + " oui-checkbox-field" },
                React.createElement(types_1.FieldContextProvider, { value: { hintId: hintId, errorId: errorId, fieldName: fieldName, label: label, fieldId: this.fieldId } },
                    React.createElement(LegacyFieldContextProvider, { hintId: hintId, fieldName: fieldName, errorId: errorId, fieldId: this.fieldId, label: label }, children)),
                unicode_1.nonBreakingSpace,
                React.createElement("div", { className: "oui-display-inline-block oui-text-top" },
                    checkboxLabelElement,
                    React.createElement("span", { className: "oui-margin-small-bottom oui-margin-small-left" }, tooltipElement),
                    hintElement,
                    React.createElement(FieldError_1.default, { fieldName: fieldName, inline: true, errorId: errorId, error: error }))));
        }
        return (React.createElement("div", { className: className },
            React.createElement("span", { className: "oui-flex oui-flex-middle" },
                labelElement,
                descriptionFlag,
                " ",
                React.createElement("span", { className: "oui-margin-small-bottom oui-margin-small-left" }, tooltipElement)),
            React.createElement(types_1.FieldContextProvider, { value: { hintId: hintId, errorId: errorId, fieldName: fieldName, label: label, fieldId: this.fieldId } },
                React.createElement(LegacyFieldContextProvider, { hintId: hintId, errorId: errorId, fieldName: fieldName, fieldId: this.fieldId, label: label }, children)),
            hintElement,
            React.createElement(FieldError_1.default, { fieldName: fieldName, error: error, errorId: errorId })));
    };
    return Field;
}(React.Component));
exports.default = Field;
//# sourceMappingURL=Field.js.map